import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
// eslint-disable-next-line no-restricted-imports
import { Controller } from 'react-hook-form-v7';
import { COLORS } from '../../../utils/Application_Constants';

export const expenseFileSourceOptions = {
    corpay: {
        label: 'Corpay',
        value: 'corpay',
    },
    conferma: {
        label: 'Conferma',
        value: 'conferma',
    },
    travelinc: {
        label: 'Travel Inc',
        value: 'travelinc',
    },
    vault: {
        label: 'Vault',
        value: 'vault',
    },
};

const styles = () => ({
    radioLabel: {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '20px',
    },
    formControl: {
        marginBottom: 0,
    },
    asterisk: {
        color: COLORS.LT_PEPPER,
    },
});

const ExpensesSourceRadioGroup = ({ classes, control }) => {
    const { ltoeWebExpensesEnableVaultChargesFileUpload: isVaultChargesFileUploadEnabled } =
        useFlags();
    return (
        <Controller
            control={control}
            rules={{ required: 'Source is required' }}
            defaultValue=""
            name="importer"
            render={({ field, fieldState: { error } }) => (
                <FormControl component="fieldset" className={classes.formControl} error={!!error}>
                    <FormLabel
                        id="source-label"
                        classes={{ asterisk: classes.asterisk }}
                        sx={{ fontSize: '12px', fontWeight: '700', color: '#2a3953' }}
                        required
                    >
                        Source
                    </FormLabel>
                    <RadioGroup {...field} aria-label="importer" row aria-labelledby="source-label">
                        <FormControlLabel
                            classes={{ label: classes.radioLabel }}
                            value={expenseFileSourceOptions.corpay.value}
                            control={<Radio color="primary" />}
                            label={expenseFileSourceOptions.corpay.label}
                        />
                        <FormControlLabel
                            classes={{ label: classes.radioLabel }}
                            value={expenseFileSourceOptions.conferma.value}
                            control={<Radio color="primary" />}
                            label={expenseFileSourceOptions.conferma.label}
                        />
                        <FormControlLabel
                            classes={{ label: classes.radioLabel }}
                            value={expenseFileSourceOptions.travelinc.value}
                            control={<Radio color="primary" />}
                            label={expenseFileSourceOptions.travelinc.label}
                        />
                        {isVaultChargesFileUploadEnabled && (
                            <FormControlLabel
                                classes={{ label: classes.radioLabel }}
                                value={expenseFileSourceOptions.vault.value}
                                control={<Radio color="primary" />}
                                label={expenseFileSourceOptions.vault.label}
                            />
                        )}
                    </RadioGroup>
                    <FormHelperText sx={{ ml: 0 }}>{error && error.message}</FormHelperText>
                </FormControl>
            )}
        />
    );
};

export default withStyles(styles)(ExpensesSourceRadioGroup);
